import {axiosMiddleware, windowMiddleware} from "./api";
import firewall from './Firewall';
import {createLogger} from 'redux-logger';
const logger = createLogger();
import promise from 'redux-promise';
import thunk from 'redux-thunk';

export default [
    thunk,
    promise,
    axiosMiddleware,
    // windowMiddleware,
    firewall,
    logger
]



// WEBPACK FOOTER //
// ./src/redux/middlewares/index.js